import PieChartSection from './PieChartSection';

export default PieChartSection;
